export default "__VITE_ASSET__4abf07af__"